import { PercentPointCell } from "app/components/React/Table/cells/PercentPointCell";
import { IndexCell, TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";
import type { ISortedColumn } from "app/@types/userdata";

import { SelectCellSite } from "../folders/foldersTable/FoldersTableConfig";
import { navigateToKeywordDetailPage } from "../folders/utils";

const DROP_DOWN_OPTIONS = [
    {
        get text() {
            return translate("search.pages.table.columns.explore");
        },
        onClick: (value: string) => {
            navigateToKeywordDetailPage({ keyValue: value, searchType: "exact" });
        },
        icon: "keywords",
    },
];

const PagesTableColumns = [
    {
        fixed: false,
        cellComponent: IndexCell,
        headerComponent: DefaultCellHeader,
        disableHeaderCellHover: true,
        sortable: false,
        width: 65,
        visible: true,
    },
    {
        field: `Page`,
        trackingName: `URL`,
        type: "string",
        format: "None",
        get displayName() {
            return translate("analysis.content.pop.pages.table.columns.domain.title");
        },
        get tooltip() {
            return translate("analysis.content.pop.pages.table.columns.domain.title.tooltip");
        },
        headerComponent: DefaultCellHeader,
        cellComponent: SelectCellSite(),
        minWidth: 500,
        dropDownOptions: DROP_DOWN_OPTIONS,
        sortable: true,
        isSorted: false,
        sortDirection: "desc",
        showTotalCount: true,
        visible: true,
    },
    {
        field: "Share",
        get displayName() {
            return translate("analysis.content.pop.pages.table.columns.share.title");
        },
        type: "double",
        format: "percentagesign",
        sortable: true,
        isSorted: true,
        sortDirection: "desc",
        cellComponent: TrafficShare,
        headerComponent: DefaultCellHeader,
        get tooltip() {
            return translate("analysis.content.pop.pages.table.columns.share.title.tooltip");
        },
        minWidth: 300,
        visible: true,
    },
    {
        field: "Change",
        get displayName() {
            return translate("global.change");
        },
        type: "double",
        format: "percentagesign",
        sortable: true,
        isSorted: false,
        sortDirection: "desc",
        cellComponent: PercentPointCell,
        headerComponent: DefaultCellHeaderRightAlign,
        get tooltip() {
            return translate("analysis.content.pop.pages.table.columns.change.title.tooltip");
        },
        width: 110,
        visible: true,
    },
];

export const getTableColumns = (sortedColumn: ISortedColumn) => {
    return PagesTableColumns.map((col) => {
        if (!col.sortable) {
            return col;
        }
        return {
            ...col,
            isSorted: col.field === sortedColumn.field,
            sortDirection: col.field === sortedColumn.field ? sortedColumn.sortDirection : col.sortDirection,
        };
    });
};
